export default "__VITE_ASSET__BpiCtz_0__"